import { IEquipment } from '@/pages/Equipment/equipment.types'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'
import liftPlateContactsMatrixConfig from '../liftPlateContactsMatrix.config'
import LiftPlateContactsMatrixWidget from '../LiftPlateContactsMatrixWidget'
import useParametersValues from '@/services/data/hooks/useParametersValues'
import { useMemo } from 'react'

interface IProps {
  equipmentId: IEquipment['id']

  live: boolean
  ts: number // unix ts in ms
}

/**
 * Матрциа контактов - буквально матрица внутри станции управления лифта, к которой подключаются множество модулей.
 * Виджет отображает факт налаичия или отсутствия сигналов по этим модулям
 * */
const LiftPlateContactsMatrixRealtime = (props: IProps) => {
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const config = useMemo(
    () => ({
      ts: props.ts,
      live: props.live,
      equipmentId: props.equipmentId,
      parameters: liftPlateContactsMatrixConfig.sourceParametersMap
        .flatMap((el) => el)
        .map((e) => sourceIdToIdMap[e])
        .filter(Boolean),
    }),
    [sourceIdToIdMap, props.ts, props.equipmentId, props.live]
  )

  const valuesCtrl = useParametersValues(config)

  return <LiftPlateContactsMatrixWidget values={valuesCtrl.values} loading={valuesCtrl.loading} />
}

export default LiftPlateContactsMatrixRealtime
